import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

/**
 * Shows the element's action as a native navigation bar button instead, and clicks the element when it is tapped.
 * Does nothing in a browser or in builds that do not register the component, so the element stays as it is.
 * Attach it to a link or button with data-controller="bridge--button". The title comes from data-bridge-title, the
 * aria-label or the element's text. Set data-bridge--button-hide-value to a CSS selector for an ancestor to hide
 * along with the element (for example a banner around it) once the native button is showing.
 */
export default class ButtonController extends BridgeComponent {
  public static component = 'button';
  public static values = { hide: String };
  declare private readonly hideValue: string;
  declare private readonly hasHideValue: boolean;

  public connect(): void {
    super.connect();

    const { title } = this.bridgeElement;

    this.send('connect', { title }, () => {
      this.bridgeElement.click();
    });

    this._hideElement(true);
  }

  public disconnect(): void {
    super.disconnect();
    this._hideElement(false);
  }

  private _hideElement(hidden: boolean): void {
    if (!this.enabled) {
      return;
    }

    const target = this.hasHideValue
      ? this.element.closest<HTMLElement>(this.hideValue)
      : (this.element as HTMLElement);

    target?.classList.toggle('d-none', hidden);
  }
}
